import React from 'react'
import { CircularProgress, Backdrop } from '@mui/material'

const OverlayLoader = ({ visible }) => {
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={visible}
    >
      <CircularProgress color="error" />
    </Backdrop>
  )
}

export default OverlayLoader
